<template>
  <div class="promote-page-container">
    <!-- 1. Hero Section -->
    <div class="promote-hero">
      <div class="hero-overlay">
        <h1 class="hero-headline">Partner with Tulum's #1 Nightlife Guide</h1>
        <p class="hero-subheadline">
          Connect your brand with a global audience of travelers actively searching for Tulum's best experiences. From legendary parties to exclusive dinner reservations, we put you in front of the customers you want.
        </p>
      </div>
    </div>

    <div class="promote-content">
      <!-- 2. "Choose Your Partnership" Section -->
      <section class="partnership-section">
        <h2>What Would You Like to Promote?</h2>
        <div class="partnership-cards">
          <!-- Card 1: For Venues -->
          <div class="partnership-card">
            <h3>Promote Your Club or Restaurant</h3>
            <p>Drive high-value bookings for your most profitable offerings. We specialize in connecting our audience with premium experiences like table reservations, exclusive dinners, and special venue nights.</p>
            <button class="cta-btn" @click="showForm('venue')">Promote My Venue</button>
          </div>
          <!-- Card 2: For Events -->
          <div class="partnership-card">
            <h3>List Your Event</h3>
            <p>Sell more tickets and attract a premium crowd. Our platform is the #1 source for event discovery in Tulum. Use our reach to not only fill your event but also to drive high-value table sales.</p>
            <button class="cta-btn" @click="showForm('event')">List My Event</button>
          </div>
        </div>
      </section>

      <!-- 3. "Why Partner With Us?" Section -->
      <section class="why-us-section">
        <h2>Why Partner With Tulum.Party?</h2>
        <ul>
          <li><strong>Unrivaled Audience:</strong> Get direct access to thousands of international tourists ready to book premium experiences.</li>
          <li><strong>A Trusted Brand:</strong> Leverage the authority of Tulum's most respected nightlife guide to enhance your own brand's credibility.</li>
          <li><strong>A True Partnership:</strong> We are local music and tech experts dedicated to your success. Our support is best-in-class because when you succeed, we succeed.</li>
        </ul>
      </section>

      <!-- 4. Submission Form Section -->
      <section v-if="formType" class="form-section" ref="formSection">
        <h2 class="form-title">{{ formTitle }}</h2>
        <form @submit.prevent="handleSubmit">
          <!-- Venue Form Fields -->
          <template v-if="formType === 'venue'">
            <div class="form-group">
              <label for="venueName">Venue Name*</label>
              <input type="text" id="venueName" v-model="formData.venueName" required />
            </div>
            <div class="form-group">
              <label for="venueType">Venue Type*</label>
              <select id="venueType" v-model="formData.venueType" required>
                <option disabled value="">Please select one</option>
                <option>Club</option>
                <option>Restaurant</option>
                <option>Beach Club</option>
                <option>Other</option>
              </select>
            </div>
            <div class="form-group-inline">
              <div class="form-group">
                <label for="yourNameVenue">Your Name*</label>
                <input type="text" id="yourNameVenue" v-model="formData.yourName" required />
              </div>
              <div class="form-group">
                <label for="yourEmailVenue">Your Email*</label>
                <input type="email" id="yourEmailVenue" v-model="formData.yourEmail" required />
              </div>
            </div>
            <div class="form-group">
              <label for="website">Link to your Instagram or Website</label>
              <input type="url" id="website" v-model="formData.website" />
            </div>
            <div class="form-group">
              <label>What would you like to promote?</label>
              <div class="checkbox-group">
                <div class="checkbox-item"><input type="checkbox" id="promoTables" value="Table Reservations" v-model="formData.promotionGoals" /><label for="promoTables">Table Reservations</label></div>
                <div class="checkbox-item"><input type="checkbox" id="promoDinners" value="Dinner Reservations" v-model="formData.promotionGoals" /><label for="promoDinners">Dinner Reservations</label></div>
                <div class="checkbox-item"><input type="checkbox" id="promoEvents" value="Special Events" v-model="formData.promotionGoals" /><label for="promoEvents">Special Events</label></div>
                <div class="checkbox-item"><input type="checkbox" id="promoAwareness" value="General Awareness" v-model="formData.promotionGoals" /><label for="promoAwareness">General Awareness</label></div>
              </div>
            </div>
          </template>

          <!-- Event Form Fields -->
          <template v-if="formType === 'event'">
            <div class="form-group">
              <label for="eventName">Event Name*</label>
              <input type="text" id="eventName" v-model="formData.eventName" required />
            </div>
            <div class="form-group-inline">
              <div class="form-group">
                <label for="eventDate">Event Date*</label>
                <input type="date" id="eventDate" v-model="formData.eventDate" required />
              </div>
              <div class="form-group">
                <label for="venueNameEvent">Venue Name*</label>
                <input type="text" id="venueNameEvent" v-model="formData.venueName" required />
              </div>
            </div>
            <div class="form-group-inline">
              <div class="form-group">
                <label for="yourNameEvent">Your Name*</label>
                <input type="text" id="yourNameEvent" v-model="formData.yourName" required />
              </div>
              <div class="form-group">
                <label for="yourEmailEvent">Your Email*</label>
                <input type="email" id="yourEmailEvent" v-model="formData.yourEmail" required />
              </div>
            </div>
            <div class="form-group">
              <label for="ticketLink">Link to Ticket Sales Page</label>
              <input type="url" id="ticketLink" v-model="formData.ticketLink" />
            </div>
            <div class="form-group">
              <label>Do you offer table reservations for this event?</label>
              <div class="radio-group">
                <div class="radio-item"><input type="radio" id="tablesYes" value="Yes" v-model="formData.hasTables" /><label for="tablesYes">Yes</label></div>
                <div class="radio-item"><input type="radio" id="tablesNo" value="No" v-model="formData.hasTables" /><label for="tablesNo">No</label></div>
              </div>
            </div>
          </template>

          <!-- Common Fields -->
          <div class="form-group">
            <label for="message">Message (Optional)</label>
            <textarea id="message" v-model="formData.message" rows="4"></textarea>
          </div>

          <button type="submit" class="submit-btn">{{ submitButtonText }}</button>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotePage',
  metaInfo() {
    return {
      title: 'Partner With Us | Promote Your Event or Venue | tulum.party',
      meta: [
        { name: 'description', content: 'Promote your club, restaurant, or event with Tulum\'s #1 nightlife guide. Reach a global audience of travelers and sell more tickets and tables.' },
        { property: 'og:title', content: 'Partner with Tulum\'s #1 Nightlife Guide' },
      ]
    };
  },
  data() {
    return {
      heroImage: 'https://imgix.cosmicjs.com/b06f8970-3c13-11f0-9a35-25ab32aeb3ca-riviera-maya-sunset.jpg',
      formType: null, // 'venue', 'event', or null
      formData: this.getInitialFormData(),
    };
  },
  computed: {
    formTitle() {
      return this.formType === 'venue' ? 'Promote Your Venue' : 'List Your Event';
    },
    submitButtonText() {
      return this.formType === 'venue' ? 'Submit Inquiry' : 'Submit Event';
    }
  },
  methods: {
    getInitialFormData() {
      return {
        // Venue fields
        venueName: '',
        venueType: '',
        promotionGoals: [],
        // Event fields
        eventName: '',
        eventDate: '',
        ticketLink: '',
        hasTables: 'No',
        // Common fields
        yourName: '',
        yourEmail: '',
        website: '',
        message: '',
      };
    },
    showForm(type) {
      this.formType = type;
      this.formData = this.getInitialFormData(); // Reset form data on type change

      // Use $nextTick to ensure the form is in the DOM before scrolling
      this.$nextTick(() => {
        this.$refs.formSection.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSubmit() {
      console.log('Form Submitted!', {
        formType: this.formType,
        data: this.formData
      });
      // Here you would typically make an API call to your backend
      // or a service like Formspree.
      alert('Thank you for your submission! We will get back to you shortly.');
      this.formType = null; // Hide form after submission
    }
  }
};
</script>

<style scoped>
.promote-page-container {
  background-color: #1a1a1c;
  color: #f0f0f0;
}

.promote-hero {
  min-height: 50vh;
  background-size: cover;
  background-position: center 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.hero-overlay {
  background: linear-gradient(to top, rgba(26, 26, 28, 1) 0%, rgba(26, 26, 28, 0.5) 100%);
  text-align: center;
  padding: 2rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-headline {
  font-size: 3.5rem;
  font-weight: 900;
  color: #fff;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
  max-width: 800px;
  margin-bottom: 1rem;
}

.hero-subheadline {
  font-size: 1.25rem;
  max-width: 700px;
  line-height: 1.6;
  color: #ccc;
}

.promote-content {
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
}

section {
  margin-bottom: 4rem;
}

section h2 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #00c6ff;
  margin-bottom: 2rem;
}

.partnership-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.partnership-card {
  background-color: #252528;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #333;
  display: flex;
  flex-direction: column;
}

.partnership-card h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.partnership-card p {
  color: #ccc;
  line-height: 1.7;
  flex-grow: 1;
  margin-bottom: 2rem;
}

.cta-btn {
  background-color: #00c6ff;
  color: #1a1a1c;
  padding: 0.8rem 1.8rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.1rem;
  transition: transform 0.2s ease, background-color 0.2s ease;
  border: none;
  cursor: pointer;
}

.cta-btn:hover {
  background-color: #fff;
  transform: translateY(-3px);
}

.why-us-section ul {
  list-style: none;
  padding: 0;
  max-width: 800px;
  margin: 0 auto;
}

.why-us-section li {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #ddd;
  padding-left: 2rem;
  position: relative;
  margin-bottom: 1rem;
}

.why-us-section li::before {
  content: '✅';
  position: absolute;
  left: 0;
  top: 5px;
}

.form-section {
  background-color: #252528;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #444;
}

.form-title {
  color: #fff;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group-inline {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group-inline .form-group {
  flex: 1;
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group input[type="url"],
.form-group input[type="date"],
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.8rem;
  background-color: #3a3a3c;
  border: 1px solid #555;
  border-radius: 5px;
  color: #f0f0f0;
  font-size: 1rem;
}

.checkbox-group, .radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.checkbox-item, .radio-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  font-size: 1.2rem;
  font-weight: 700;
  background-color: #00c6ff;
  color: #1a1a1c;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.submit-btn:hover {
  background-color: #fff;
}

@media (max-width: 768px) {
  .hero-headline { font-size: 2.5rem; }
  .partnership-cards { grid-template-columns: 1fr; }
  .form-group-inline { flex-direction: column; }
}
</style>
